import React from "react";
import { Avatar, Card, Space, Typography } from "antd";
import { EllipsisOutlined} from "@ant-design/icons";
import TextRenderer from "../../utils/TextUtils/textRendererForLivePreview";
import {useTranslation} from "react-i18next";

export default function FacebookPreview({
                                            text = "",
                                            images = [],
                                            image,                 // старый проп поддержан
                                            profileName,
                                            publisherName
                                        }) {
    const [expanded, setExpanded] = React.useState(false);
    const clamp = 420;

    const imgs = React.useMemo(() => {
        const raw = (images && images.length ? images : (image ? [image] : [])) || [];
        return raw
            .map((it) =>
                typeof it === "string"
                    ? { url: it }
                    : { url: it?.url || it?.path || it?.src || it?.imageUrl || "" }
            )
            .filter((i) => !!i.url);
    }, [images, image]);

    const count = imgs.length;

    // показываем до 5 (1 большая + до 4 маленьких); если >5 — оверлей на 5-й
    const showCount = count > 4 ? 5 : count;
    const show = imgs.slice(0, showCount);
    const extra = Math.max(0, count - 4);

    const big = show[0];
    const small = show.slice(1); // 2..5 плитки

    const uname = profileName || "Business Page";
    const pby = publisherName || "IMean-Dev";
    const initial = uname?.[0]?.toUpperCase() || "F";

    const {t } = useTranslation();

    const tile = (url, ratio = "1/1", radius = 8) => ({
        width: "100%",
        aspectRatio: ratio,
        background: url ? `url(${url}) center/cover no-repeat` : "#f0f0f0",
        borderRadius: radius,
        overflow: "hidden",
        position: "relative",
    });

    return (
        <Card size="small" bordered>
            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                <Space align="center">
                    <Avatar size={36} style={{ background: "#1877f2" }}>{initial}</Avatar>
                    <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
                        <Typography.Text strong style={{ marginBottom: 2 }}>{uname}</Typography.Text>
                    </div>
                </Space>
                <EllipsisOutlined style={{ fontSize: 18, color: "#595959" }} />
            </div>

            {/* Text */}
            {text && (
                <Typography.Paragraph style={{ margin: "0 0 8px 0", lineHeight: 1.35 }}>
                    {expanded ? (
                        <>
                            <TextRenderer text={text} />
                            <Typography.Link onClick={() => setExpanded(false)} style={{ display: "block", marginTop: 4, padding: 0 }}>
                                {t("post.rollUp")}
                            </Typography.Link>
                        </>
                    ) : (
                        <>
                            <TextRenderer text={text} clampChars={clamp} />{" "}
                            {text.length > clamp && (
                                <Typography.Link onClick={() => setExpanded(true)} style={{ padding: 0 }}>
                                    {t("post.showMore")}
                                </Typography.Link>
                            )}
                        </>
                    )}
                </Typography.Paragraph>
            )}

            {/* Media */}
            <div style={{ width: "100%" }}>
                {count === 1 && (
                    <div style={tile(big?.url, "16/9")} />
                )}

                {count === 2 && (
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
                        <div style={tile(show[0]?.url, "1/1", 8)} />
                        <div style={tile(show[1]?.url, "1/1", 8)} />
                    </div>
                )}

                {count === 3 && (
                    <>
                        <div style={{ ...tile(show[0]?.url, "16/9", 8), marginBottom: 6 }} />
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
                            <div style={tile(show[1]?.url, "1/1", 6)} />
                            <div style={tile(show[2]?.url, "1/1", 6)} />
                        </div>
                    </>
                )}

                {count === 4 && (
                    <>
                        <div style={{ ...tile(show[0]?.url, "16/9", 8), marginBottom: 6 }} />
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
                            {show.slice(1, 4).map((img, i) => (
                                <div key={i} style={tile(img?.url, "1/1", 6)} />
                            ))}
                        </div>
                    </>
                )}

                {count > 4 && (
                    <>
                        {/* верхний ряд — две большие карточки */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6, marginBottom: 6 }}>
                            <div style={tile(show[0]?.url, "16/9", 8)} />
                            <div style={tile(show[1]?.url, "16/9", 8)} />
                        </div>

                        {/* нижний ряд — три маленьких, оверлей на третьей */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 6 }}>
                            {show.slice(2, 5).map((img, i) => {
                                const isOverlay = i === 2 && extra > 1; // третья в нижнем ряду
                                return (
                                    <div key={i} style={tile(img?.url, "1/1", 6)}>
                                        {isOverlay && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    inset: 0,
                                                    background: "rgba(0,0,0,0.45)",
                                                    color: "#fff",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    fontWeight: 700,
                                                    fontSize: 22,
                                                }}
                                            >
                                                +{extra}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
        </Card>
    );
}
